import React from 'react'
import { connect } from 'react-redux'
import AdminLayout from '../components/AdminLayout'
import SectionContent from '../components/SectionContent'
import Tests from './Tests'
import ChartCheckCount from './Dashboard/ChartCheckCount'
import ChartCheckSum from './Dashboard/ChartCheckSum'
import SMSStat from './Dashboard/SMSStat'
import CryptoJS from 'crypto-js'
import config from '../config/index'

class Dashboard extends React.Component {
  render() {
    const userId = CryptoJS.AES.decrypt(localStorage.getItem('userId') ? localStorage.getItem('userId') : '', config.api.cryptoKey).toString(CryptoJS.enc.Utf8)
    const fullAccess = userId === '5' || userId === '1' || userId === '24' || userId === '25' || userId === '27' || userId === '28' || userId === '29'

    return (
      <AdminLayout>
        {fullAccess &&
          <React.Fragment>
            <SectionContent>
              <Tests />
            </SectionContent>
            <SectionContent title='Отправленные СМС'>
              <SMSStat />
            </SectionContent>
            <SectionContent title='Количество чеков'>
              <ChartCheckCount />
            </SectionContent>
            <SectionContent title=' Сумма чеков'>
              <ChartCheckSum />
            </SectionContent>
          </React.Fragment>
        }
      </AdminLayout>
    )
  }
}

export default connect()(Dashboard)



// WEBPACK FOOTER //
// src/containers/Dashboard.jsx